window.mmajaxcart = {
  AjaxcartOpen: function() {
    var body = $('body'),
        ajaxCart = $('.mm-ajaxcart'),
        ajaxOverlay = $('.mm-ajaxcart-overlay');

    body.addClass('mm-no-scroll');
    ajaxCart.addClass('has--opened');      
    ajaxOverlay.addClass('has--active');
    
  },
  AjaxcartClose: function() {
    var body = $('body'),
        ajaxCart = $('.mm-ajaxcart'),           	
        ajaxOverlay = $('.mm-ajaxcart-overlay');

    body.removeClass('mm-no-scroll');
    ajaxCart.removeClass('has--opened');      
    ajaxOverlay.removeClass('has--active');       
  },
  AjaxcartRender: function() {
    $.get('/cart?view=mm-ajax', function(cart){
      $('.mm-ajaxcart').html(cart);
    });
    
    $.getJSON('/cart', function(cart){ 
      for(i=0; i < cart.items.length ; i++){
        if (cart.items[i].id == '40164789289113'){
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              quantity: 0,
              id: 40164789289113
            },
            success: function(){
              mmajaxcart.AjaxcartRender();
              mmajaxcart.CartCountHandler();
              
            },
            error: function(){}
          });
        }
      }
    });
  },
  CartCountHandler: function() {
    $.getJSON('/cart.js', function(cart) {
      $('.mm-ajaxcart-open .cart_count').text(cart.item_count);
    })
  },
  AjaxcartChangeHandler: function(data) {    
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: data,
      success: function (cart) {
        mmajaxcart.AjaxcartRender();
        mmajaxcart.CartCountHandler();
        
            $.get(theme.routes.search_url, function (data) {
          var $parsedData = $('<div>' + data + '</div>');
          var cartSummarySelectors = ['.page-header .cartsummary'];

          for (var i = 0; i < cartSummarySelectors.length; i++) {
            var $newCartObj = $parsedData.find(cartSummarySelectors[i]).first();
            var $currCart = $(cartSummarySelectors[i]);
            $currCart.html($newCartObj.html());
            /*Sticky cart price update*/
            $('#CartSubtotal_sticky').text($('#CartSubtotal').text());
            $('#sticky_cart_item').text('Total price of '+$('#cartcount_top').text()+' products');
            /*Remove Class if cart item > 0 */
            $('#cart-badge').removeClass('d-none');
//             alert('hide');
          }
          
          
        });
        
        
      }
    });
  },
  AjaxcartQuantityHandler: function() {
    $(document).on('click', '.quantity-plus', function() {
      let q = $(this).parent().find('.quantity-input').val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) + p;
      $(this).parent().find('.quantity-input').val(u).trigger('change');
    })
    $(document).on('click', '.quantity-minus', function() {
      let q = $(this).parent().find('.quantity-input').val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) - p;
      $(this).parent().find('.quantity-input').val(u).trigger('change');
    })
    $(document).on('change', '.quantity-input', function() {
      var UpdatedQuantity = parseInt($(this).val()),
          QuantityLine = parseInt($(this).attr('data-line')),
          params = { quantity: UpdatedQuantity, line: QuantityLine };
      
      mmajaxcart.AjaxcartChangeHandler(params);
    })
    $(document).on('click', '.mm-ajaxcart-remove-item', function() {
      var RemoveLine = parseInt($(this).attr('data-line')),
          params = { quantity: 0, line: RemoveLine };

      mmajaxcart.AjaxcartChangeHandler(params);
    })
  }
}

$(document).ready(function() { 
  $(document).on('click', '.mm-ajaxcart-open', function(e) {
  	e.preventDefault();
    mmajaxcart.AjaxcartOpen();
  })
  $(document).on('click', '.mm-ajaxcart-close,.mm-ajaxcart-overlay', function(e) {
    e.preventDefault();
    mmajaxcart.AjaxcartClose();
  });
  $(document).on('click', '.searchtap_mm-ajax-add', function(e) {
    setTimeout(function () {
      mmajaxcart.AjaxcartRender();
      mmajaxcart.AjaxcartOpen(); 
    }, 500);
  });
  $(document).on('click', '.ajax-submit',  function(e) {
  	
    
    e.preventDefault();
    var self = $(this);
    
    var $addToCartForm = self.closest('form');
    
    /*For Hide Add to cart button on click*/
    var adc_id= $(this).attr('id');
    var $btn = $('.product-purchase-form').find('button[type="submit"]').removeAttr('disabled'); // Show added message
    
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      success: function (data) {
        mmajaxcart.CartCountHandler();        
        mmajaxcart.AjaxcartRender();
        /*On Add To cart button click to show ajaxcart sidebar popup using this function*/
//      mmajaxcart.AjaxcartOpen();
        
         /*For Hide Add to cart button on click*/
         setTimeout(function () {
          $btn.html(theme.strings.products_product_add_to_cart);
		  /*For Hide Add to cart button for specified block on click*/
          $('#'+ adc_id).hide();   
          $('#qty'+ adc_id).show();
          $('#prdtotal'+ adc_id).show();
 
          
        }, 3000); // Added, show CTA
        /*------------------*/
        
        
        $.get(theme.routes.search_url, function (data) {
          var $parsedData = $('<div>' + data + '</div>');
          var cartSummarySelectors = ['.page-header .cartsummary'];

          for (var i = 0; i < cartSummarySelectors.length; i++) {
            var $newCartObj = $parsedData.find(cartSummarySelectors[i]).first();
            var $currCart = $(cartSummarySelectors[i]);
            $currCart.html($newCartObj.html());
            /*Sticky cart price update*/
            $('#CartSubtotal_sticky').text($('#CartSubtotal').text());
            $('#sticky_cart_item').text('Total price of '+$('#cartcount_top').text()+' products');
            /*Remove Class if cart item > 0 */
            $('#cart-badge').removeClass('d-none');
          }
          
          
        });
        
        
      }
      
      
      
    });

    
  })
  mmajaxcart.AjaxcartRender();
  mmajaxcart.AjaxcartQuantityHandler();
  
  $(document).on('click','.minclick, .plusclick', function() {
  	
    var vId = $(this).data('id');    
    var vPrice = $(this).data('price');
    var q = $('#qty'+vId+' #quantity').val();
    var SinTotal = (parseFloat(q)) * (parseFloat(vPrice));
    $('#count'+vId).html('<span id="rupee-symbol">₹</span>'+SinTotal.toFixed(2));
    $('.quantity-input[data-proid="'+vId+'"]').val(q).trigger('change');
    
  });
})